import { EMoneySource } from '../../types/reducers/user';

export type TMoneySourceHandleChange = (source: EMoneySource) => void;

export enum EMoneySourceWidgetType {
  Buttons = 'Buttons',
  Tabs = 'Tabs',
}

export interface IMoneySourceProps {
  value: EMoneySource;
  disabled: boolean;
  active: boolean;
  label: string;
}

export interface IUseMoneySource {
  options: Array<IMoneySourceProps>;
  widgetType: EMoneySourceWidgetType;
  onChange: (value: EMoneySource) => void;
  isRender: boolean;
}

export interface IUseMoneySourceAnalytics {
  trackMoneySourceClick(source: EMoneySource): void;
}

export interface ITrackMoneySourceClickAnalyticsExtra {
  source: EMoneySource;
}
